import styled from 'styled-components';
import { typography } from '@clds/typography';
import { messages } from '../../i18n/upgradeModalMessages';
import { useIntl } from 'react-intl';

const HeaderTitle = styled.div`
  ${typography.lg.regular};
  font-weight: 700;
  margin-bottom: ${(props) => props.theme.spacing.md};
`;

const Note = styled.div`
  ${typography.md.highContrast};
  font-weight: 400;
  margin-bottom: ${(props) => props.theme.spacing.lg};
`;

interface UpgradeHeaderProps {
  modelPopupKind: 'addProductEnvModal' | 'addUserModal';
}

export const UpgradeHeader = ({ modelPopupKind }: UpgradeHeaderProps) => {
  const { formatMessage } = useIntl();

  const titles = {
    addProductEnvModal: formatMessage(messages.headerTitleProductEnv),
    addUserModal: formatMessage(messages.headerTitleAddUser),
  };

  const notes = {
    addProductEnvModal: formatMessage(messages.noteProductEnv),
    addUserModal: formatMessage(messages.noteAddUser),
  };
  return (
    <>
      {modelPopupKind && (
        <>
          <HeaderTitle data-testid="header-title">{titles[modelPopupKind]}</HeaderTitle>
          <Note data-testid="note-modal">{notes[modelPopupKind]}</Note>
        </>
      )}
    </>
  );
};
